<div class="rendelo-detail-page">
    <mat-card>
        <mat-card-header>
            <mat-card-title>Páciens részletek</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            @if (loading()) {
                <p>Betöltés...</p>
            } @else if (error()) {
                <p class="error">{{ error() }}</p>
            } @else if (paciens()) {
                <div class="detail-container">
                    <!-- Basic Information -->
                    <section class="detail-section">
                        <h3>Alapadatok</h3>
                        <mat-list>
                            <mat-list-item>
                                <span matListItemTitle>Név:</span>
                                <span matListItemLine>{{ paciens()?.nev }}</span>
                            </mat-list-item>
                            @if (paciens()?.szuletesiNev) {
                                <mat-list-item>
                                    <span matListItemTitle>Születési név:</span>
                                    <span matListItemLine>{{ paciens()?.szuletesiNev }}</span>
                                </mat-list-item>
                            }
                            <mat-list-item>
                                <span matListItemTitle>Nem:</span>
                                <span matListItemLine>{{ getNemLabel(paciens()!.nem) }}</span>
                            </mat-list-item>
                            @if (paciens()?.tajszam) {
                                <mat-list-item>
                                    <span matListItemTitle>TAJ szám:</span>
                                    <span matListItemLine>{{ paciens()?.tajszam }}</span>
                                </mat-list-item>
                            }
                            @if (paciens()?.szuletett) {
                                <mat-list-item>
                                    <span matListItemTitle>Születési dátum:</span>
                                    <span matListItemLine>{{ paciens()?.szuletett }}</span>
                                </mat-list-item>
                            }
                            @if (paciens()?.lakCim) {
                                <mat-list-item>
                                    <span matListItemTitle>Lakcím:</span>
                                    <span matListItemLine>{{ paciens()?.lakCim }}</span>
                                </mat-list-item>
                            }
                        </mat-list>
                    </section>

                    <mat-divider></mat-divider>

                    <!-- Contact Information -->
                    <section class="detail-section">
                        <h3>Elérhetőségek</h3>

                        @if (paciens()?.telefonok && paciens()!.telefonok.length > 0) {
                            <div class="contact-group">
                                <h4>Telefonszámok</h4>
                                <mat-list>
                                    @for (telefon of paciens()!.telefonok; track telefon.id) {
                                        <mat-list-item>
                                            <span matListItemTitle>{{ telefon.telefonTipus }}:</span>
                                            <span matListItemLine>{{ telefon.telefonSzam }}
                                                @if (telefon.isPrimary) {
                                                    <mat-chip class="primary-chip">Elsődleges</mat-chip>
                                                }
                                            </span>
                                        </mat-list-item>
                                    }
                                </mat-list>
                            </div>
                        }

                        @if (paciens()?.emailek && paciens()!.emailek.length > 0) {
                            <div class="contact-group">
                                <h4>Email címek</h4>
                                <mat-list>
                                    @for (email of paciens()!.emailek; track email.id) {
                                        <mat-list-item>
                                            <span matListItemTitle>{{ email.emailTipus }}:</span>
                                            <span matListItemLine>{{ email.emailCim }}
                                                @if (email.isPrimary) {
                                                    <mat-chip class="primary-chip">Elsődleges</mat-chip>
                                                }
                                            </span>
                                        </mat-list-item>
                                    }
                                </mat-list>
                            </div>
                        }
                    </section>

                    <mat-divider></mat-divider>

                    <!-- Languages -->
                    @if (paciens()?.nyelvek && paciens()!.nyelvek.length > 0) {
                        <section class="detail-section">
                            <h3>Nyelvek</h3>
                            <mat-chip-set>
                                @for (nyelv of paciens()!.nyelvek; track $index) {
                                    <mat-chip>{{ nyelv }}</mat-chip>
                                }
                            </mat-chip-set>
                        </section>

                        <mat-divider></mat-divider>
                    }

                    <!-- Financing Companies -->
                    @if (paciens()?.finanszirozoCegek && paciens()!.finanszirozoCegek.length > 0) {
                        <section class="detail-section">
                            <h3>Finanszírozó cégek</h3>
                            <mat-list>
                                @for (ceg of paciens()!.finanszirozoCegek; track $index) {
                                    <mat-list-item>
                                        <span matListItemTitle>{{ ceg.finanszirozoCegNev }}
                                            @if (ceg.isPrimary) {
                                                <mat-chip class="primary-chip">Elsődleges</mat-chip>
                                            }
                                        </span>
                                        @if (ceg.finanszirozoCegAzonosito) {
                                            <span matListItemLine>Azonosító: {{ ceg.finanszirozoCegAzonosito }}</span>
                                        }
                                    </mat-list-item>
                                }
                            </mat-list>
                        </section>
                    }
                </div>
            }
        </mat-card-content>
    </mat-card>
</div>
